"use strict";

exports.__esModule = true;
exports.views = exports.navigate = void 0;
var navigate = {
  PREVIOUS: 'PREV',
  NEXT: 'NEXT',
  TODAY: 'TODAY',
  DATE: 'DATE'
};
exports.navigate = navigate;
var views = {
  MONTH: 'month',
  WEEK: 'week',
  WORK_WEEK: 'work_week',
  DAY: 'day',
  AGENDA: 'agenda'
};
exports.views = views;


//////////////////
// WEBPACK FOOTER
// ../~/react-big-calendar/lib/utils/constants.js
// module id = 2986
// module chunks = 121